// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Ep3M","info":"UpdateTermsInfo_info__3CjSK"};